export class Course_Formater {
  constructor(name) {
    this.name = name;
    this.type = "normal";
    this.displayedValue = [];
    this.formated_data = [];
    this.clm_fields = [];
    this.hide_public = false;
    this.passages_interm = [];
  }

  /* Initialise le template d'une course par defaut */
  setDefaultDisplayedValue() {
    this.displayedValue = [
      {
        align: "centre",
        sexColor: "non",
        entete: "Clt",
        values: [{ name: "Classement" }],
      },
      {
        align: "centre",
        sexColor: "oui",
        entete: "Nom - Prénom",
        values: [{ name: "Nom" }, { name: "Prénom" }],
      },
      {
        align: "centre",
        sexColor: "non",
        entete: "Doss.",
        values: [{ name: "Numéro" }],
      },
      {
        align: "centre",
        sexColor: "non",
        entete: "Nat",
        values: [{ name: "Nation" }],
      },
      {
        align: "centre",
        sexColor: "non",
        entete: "Clt Cat",
        values: [{ name: "Classement par Cat." }, { name: "Abbrev. Catégorie" }],
      },
      {
        align: "centre",
        sexColor: "non",
        entete: "Clt Sexe",
        values: [{ name: "Classement par Sexe" }, { name: "Sexe" }],
      },
      {
        align: "centre",
        sexColor: "non",
        entete: "Temps",
        values: [{ name: "Temps Arrondi" }],
      },
      {
        align: "centre",
        sexColor: "non",
        entete: "Club",
        values: [{ name: "Club" }],
      },
      {
        align: "centre",
        sexColor: "non",
        entete: "Licence",
        values: [{ name: "Licence" }],
      },
    ];
  }

  /* Initialise des données formatées des résultats par défaut */
  setDefaultFormatedData(resultats) {
    for (var i = 0; i < resultats.length; i++) {
      if (this.formated_data.length > 4) {
        return;
      }
      if (this.name === resultats[i]["Course"]) {
        var d = resultats[i];
        var name = d["Nom"] + " " + d["Prénom"];
        var cat = d["Classement par Cat."] + " " + d["Abbrev. Catégorie"];
        var sexe = d["Classement par Sexe"] + " " + d["Sexe"];
        this.formated_data.push({
          Clt: d["Classement"],
          "Nom - Prénom": name,
          "Doss.": d["Numéro"],
          Club: d["Club"],
          "Clt Cat": cat,
          "Clt Sexe": sexe,
          Temps: d["Temps Arrondi"],
          Nat: d["Nation"],
          Licence: d["Licence"],
        });
      }
    }
  }
  /* Mise a jour des données formatées des résultats lors d'une modification du template */
  updateFormatedData(resultats) {
    this.formated_data = [];
    for (var i = 0; i < resultats.length; i++) {
      if (this.formated_data.length > 4) {
        return;
      }
      if (this.name === resultats[i]["Course"]) {
        var d = resultats[i];
        var data = {};
        for (var j = 0; j < this.displayedValue.length; j++) {
          data[this.displayedValue[j].entete] = "";
          for (var k = 0; k < this.displayedValue[j].values.length; k++) {
            data[this.displayedValue[j].entete] += d[this.displayedValue[j].values[k].name];
            if (k < this.displayedValue[j].values.length - 1) {
              data[this.displayedValue[j].entete] += " ";
            }
          }
        }
        this.formated_data.push(data);
      }
    }
  }

  /* Mise a jour du template lors d'un changement de type de course */
  updateType(available_fields) {
    if (this.type === "temps_reel") {
      var tempsReelFields = this.getTempsReelFields(available_fields);
      this.clm_fields = tempsReelFields;
      this.displayedValue = [
        {
          align: "centre",
          sexColor: "non",
          entete: "Clt",
          values: [{ name: tempsReelFields[1] }],
        },
        {
          align: "centre",
          sexColor: "oui",
          entete: "Nom - Prénom",
          values: [{ name: "Nom" }, { name: "Prénom" }],
        },
        {
          align: "centre",
          sexColor: "non",
          entete: "Doss.",
          values: [{ name: "Numéro" }],
        },
        {
          align: "centre",
          sexColor: "non",
          entete: "Nat",
          values: [{ name: "Nation" }],
        },
        {
          align: "centre",
          sexColor: "non",
          entete: "Clt Cat",
          values: [{ name: tempsReelFields[3] }, { name: "Abbrev. Catégorie" }],
        },
        {
          align: "centre",
          sexColor: "non",
          entete: "Clt Sexe",
          values: [{ name: tempsReelFields[2] }, { name: "Sexe" }],
        },
        {
          align: "centre",
          sexColor: "non",
          entete: "Temps",
          values: [{ name: tempsReelFields[0] }],
        },
        {
          align: "centre",
          sexColor: "non",
          entete: "Club",
          values: [{ name: "Club" }],
        },
        {
          align: "centre",
          sexColor: "non",
          entete: "Licence",
          values: [{ name: "Licence" }],
        },
      ];
    } else if (this.type === "normal") {
      this.setDefaultDisplayedValue();
      this.clm_fields = [];
    }
  }

  /* Identification des colonnes classement et temps lors d'une course de type temps réel */
  getTempsReelFields(available_fields) {
    var fields = ["Temps Arrondi", "Classement", "Classement par Sexe", "Classement par Cat."];
    for (var i = 0; i < available_fields.length; i++) {
      if (available_fields[i].name.includes("Interm (Temps réel)")) {
        fields[0] = available_fields[i].name;
      }
      if (available_fields[i].name.includes("Clt Interm-1 (Temps réel)")) {
        fields[1] = available_fields[i].name;
      }
      if (available_fields[i].name.includes("Clt Cat Interm-1 (Temps réel)")) {
        fields[3] = available_fields[i].name;
      }
      if (available_fields[i].name.includes("Clt Sex Interm-1 (Temps réel)")) {
        fields[2] = available_fields[i].name;
      }
    }
    return fields;
  }

  /* Identification des potentiel points de passages d'une course */
  findPassageInterm(resultats, fields) {
    var first_result = null;
    for (var i = 0; i < resultats.length; i++) {
      if (this.name === resultats[i]["Course"]) {
        first_result = resultats[i]; //trouve une ligne de résultat associé à la course
        break;
      }
    }
    if (first_result) {
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].name.includes("Interm ")) {
          var clt_interm_field = fields[i].name; //trouve le nom de la colonne
          if (first_result[clt_interm_field] !== "") {
            var regExp = /\(([^)]+)\)/;
            var matches = regExp.exec(fields[i].name);
            var interm_name = matches[1]; // extrait le nom du point de passage
            var passageInterm = {
              name: interm_name,
              display: false,
              temps: clt_interm_field,
              clt: "Clt Interm-1 (" + interm_name + ")",
              clt_cat: "Clt Cat Interm-1 (" + interm_name + ")",
              clt_sexe: "Clt Sex Interm-1 (" + interm_name + ")",
            };
            this.passages_interm.push(passageInterm);
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/classes/course_formater.js